import React from 'react';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import { Stages } from 'domain/shared/candidate';
import { Box } from '@mui/material';

interface CandidateInterviewStepsProps {
  activeStep: Stages;
}

const CandidateInterviewSteps: React.FC<CandidateInterviewStepsProps> = ({ activeStep }) => {
  const nonIncludeSteps = ['PendingRejection', 'Closed', 'Rejected'];
  const steps = Object.values(Stages).filter(stage => !nonIncludeSteps.includes(stage));
  const activeStepIndex = activeStep ? steps.indexOf(activeStep) : -1;
  return (
    <Stack sx={{ width: '100%' }} spacing={0}>
      <Stepper alternativeLabel activeStep={activeStepIndex} connector={null}>
        {steps.map((label, index) => (
          <Step key={label} sx={{ padding: '1px' }}>
            <Box
              sx={{
                backgroundColor: index <= activeStepIndex ? 'success.light' : 'border.default',
                padding: '5px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '3px',
                color: 'common.white',
                opacity: index < activeStepIndex ? 0.5 : 1,
              }}
            >
              {label}
            </Box>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
};

export default CandidateInterviewSteps;
